import React from "react";

const AggregateCompetitionLoad = ({competitions = [], selectedCompetition, onSelect}) => {

    return (
        <div
            style={{
                width: "100%",
                height: "420px",
                overflowY: "scroll",
                background: "#fff",
                borderRadius: "5px",
                border: "1px solid #ddd"
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed"
                }}
            >
                <thead>
                <tr style={{
                    textAlign: 'center',
                    position: "sticky",
                    top: 0,
                    background: "#f5f5f5",
                    zIndex: 2,
                    borderBottom: "2px solid #ddd"
                }}>
                    <th style={{
                        width: '60px',
                        padding: "10px",
                        textAlign: "left",
                        fontWeight: 600
                    }}>ID
                    </th>
                    <th style={{
                        padding: "10px",
                        textAlign: "left",
                        fontWeight: 600
                    }}>Название
                    </th>
                </tr>
                </thead>

                <tbody>
                {competitions.map(el => {
                    const disabled = Boolean(el.is_modify) && el.profile !== "view";
                    return (
                        <tr
                            key={el.competition_id}
                            onClick={() => {
                                if (!disabled) onSelect(el.competition_id);
                            }}
                            style={{
                                cursor: disabled ? "not-allowed" : "pointer",
                                background: disabled
                                    ? "#f0f0f0"
                                    : selectedCompetition === el.competition_id
                                        ? "#58A2E4"
                                        : "transparent",
                                color: disabled ? "#999" : "inherit",
                                opacity: disabled ? 0.6 : 1,
                                transition: "0.15s"
                            }}
                        >
                            <td style={{
                                padding: "10px",
                                borderBottom: "1px solid #eee"
                            }}>
                                {el.competition_id}
                            </td>
                            <td style={{
                                padding: "10px",
                                borderBottom: "1px solid #eee",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>
                                {el.competition_name}
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};

export default AggregateCompetitionLoad;